import { formatNumberToUI } from '@dealstack/shared/lib/format/number';
import { BlockRange } from '@dealstack/shared/lib/generated';

export const mapBlockToText = (block?: BlockRange, unitDenominator?: number) => {
	if (!block) {
		return '';
	}

	const precision = Math.log10(unitDenominator || 1);

	if (block.start === block.end) {
		return formatNumberToUI(block.start, undefined, precision);
	}

	return `${formatNumberToUI(block.start, undefined, precision)} - ${formatNumberToUI(block.end, undefined, precision)}`;
};

export const mapBlocksToText = (blocks?: BlockRange[], unitDenominator?: number) => {
	if (!blocks || blocks.length === 0) {
		return '';
	}

	return blocks.map((block) => `[${mapBlockToText(block, unitDenominator)}]`).join('; ');
};
